import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuth } from '../authNew/authSlice';
import './SharedPageLayout.css';

// Returns a short avatar label based on the user's available profile data.
const getAvatarLabel = (user) => {
  const displayName = (user?.displayName || '').trim();
  if (displayName) {
    return displayName.split(' ')[0].slice(0, 2).toUpperCase();
  }
  const email = (user?.email || '').trim();
  if (email) {
    return email.slice(0, 2).toUpperCase();
  }
  return 'ME';
};

// Renders the auth entry point for the top navigation.
const renderAuthEntry = (user) => {
  if (!user?.isLogged) {
    return (
      <a className="shared-page__link" href="/login">
        Login
      </a>
    );
  }

  return (
    <details
      className="shared-page__auth-menu"
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <summary
        style={{
          listStyle: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        {user.photoURL ? (
          <img
            src={user.photoURL}
            alt={user.displayName || 'User avatar'}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: '1px solid rgba(0, 242, 255, 0.5)',
              objectFit: 'cover'
            }}
          />
        ) : (
          <span
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: '1px solid rgba(0, 242, 255, 0.5)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              letterSpacing: '1px',
              background: 'rgba(6, 4, 20, 0.85)'
            }}
          >
            {getAvatarLabel(user)}
          </span>
        )}
      </summary>
      <div
        style={{
          position: 'absolute',
          top: '44px',
          right: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '10px',
          background: 'rgba(10, 6, 24, 0.95)',
          borderRadius: '12px',
          border: '1px solid rgba(0, 242, 255, 0.35)',
          minWidth: '160px',
          zIndex: 5
        }}
      >
        <a className="shared-page__link" href="/userData">
          User Settings
        </a>
        <a className="shared-page__link" href="/logout">
          Logout
        </a>
      </div>
    </details>
  );
};

// Renders a shared marketing layout with a top navigation bar and footer.
export function SharedPageLayout({ brand, links, footerText, navExtras, children, footerLink }) {
  const auth = useSelector(selectAuth);

  return (
    <div className="shared-page">
      <nav className="shared-page__nav">
        <div className="shared-page__nav-inner">
          <div className="shared-page__brand"><a href='/' className={`shared-page__link`}>{brand}</a></div>
          <div className="shared-page__links">
            {navExtras && <div className="shared-page__nav-extras">{navExtras}</div>}           
            {links.map((link) => (
              <a
                key={link.href}
                className={`shared-page__link${link.accent ? ' shared-page__link--accent' : ''}`}
                href={link.href}
              >
                {link.label}
              </a>
            ))}
             {/* {renderAuthEntry(auth)} */}
          </div>
        </div>
      </nav>
      <main className="shared-page__main">
        <div className="shared-page__content">{children}</div>
      </main>
      <footer className="shared-page__footer">
        <div className="shared-page__footer-inner">
          <span>{footerText}</span>
          {footerLink && (
            <a className="shared-page__link shared-page__link--footer" href={footerLink.href}>
              {footerLink.label}
            </a>
          )}
        </div>
      </footer>
    </div>
  );
}
